<template>
    <div id="files_added_imc">
        <ul>
            <li v-for="file in files">
                <a href="#" v-on:click.prevent="getFile(file)">
                    {{file.name}}
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "contragent_files",
    props : {
        id : {
            type : Number,
            default : 0,
        }
    },
    
    data() {
        return {
            is_load : false,
            files : []
        }
    },
    
    created() {
        this.loadFiles();
    },
    
    methods : {
        
        getFile(file) {
            window.location.href = '/internal/media/profile_file/' + file.id;
        },
        
        async loadFiles() {
            this.is_load = true;
            this.files = [];
            
            await api.get('/tenders/sales/tenders/contragents/' + parseInt(this.id) + '/files').then(({data}) => {
                this.is_load = false;
                if(data.status === "operation_success") {
                    this.files = data.data;
                }
            }).catch(e => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            })
        }
    }
    
}
</script>

<style scoped>

</style>